<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              class="body-1 font-weight-bold text-capitalize"
              color="white"
              icon
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                @click="$router.go(-1)"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Agenda
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="7"
              class="py-0">
              <v-card
                flat
                min-height="calc(100vh - 320px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <v-card
                    flat
                    class="mb-4"
                    style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                    <v-img 
                      contain
                      height="300"
                      alt="amanata" 
                      :src="detail.image_url === '' ? require('@/assets/image/image_default.png') : detail.image_url"
                      class="ma-auto"
                      style="border-radius: 10px;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="white">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>

                  <v-row>
                    <v-col
                      cols="12"
                      md="12">
                      <div
                        class="mb-4">
                        <div
                          class="body-1 font-weight-bold black--text">
                          {{ detail.title }}
                        </div>

                        <div
                          class="line-text-second">
                          Dibuat {{ detail.input_datetime | date }}
                        </div>
                      </div>

                      <div
                        class="mb-4">
                        <div
                          class="body-1 font-weight-bold black--text">
                          Deskripsi
                        </div>

                        <div
                          class="line-text-second">
                          {{ detail.desc }}
                        </div>
                      </div>

                      <div
                        class="mb-4">
                        <div
                          class="body-1 font-weight-bold black--text">
                          Lokasi
                        </div>

                        <div
                          class="line-text-second">
                          {{ detail.location }}
                        </div>
                      </div>

                      <div
                        class="mb-4">
                        <div
                          class="body-1 font-weight-bold black--text">
                          Tanggal & Jam
                        </div>

                        <div
                          class="line-text-second">
                          {{ detail.start_date | date }} <span class="mx-1">Pukul</span> {{ `${detail.start_time.split(':')[0]}:${detail.start_time.split(':')[1]}` }} <span class="mx-2">s/d</span> {{ detail.end_date | date }} <span class="mx-1">Pukul</span>  {{ `${detail.end_time.split(':')[0]}:${detail.end_time.split(':')[1]}` }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="5"
              class="py-0">
              <v-card
                flat
                min-height="calc(100vh - 320px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  class="d-flex justify-center my-3 mb-6">
                  <qr-code 
                    id="download_qr"
                    :text="detail.uuid"
                    :size="rps !== 'lg' ? 325 : 500">
                  </qr-code>
                </v-card-text>

                <div
                  class="text-center">
                  <v-btn
                    @click="to_download()"
                    color="green"
                    elevation="0"
                    style="border-radius: 10px;"
                    class="body-2 font-weight-bold text-capitalize white--text">
                    Download QR Kode
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="!process.load && Object.keys(detail).length > 0"
            class="pa-4 pt-0 pr-1">
            <v-col
              cols="12">
              <div
                class="d-flex align-center mb-4">
                <div
                  class="d-flex align-center">
                  Total Pengunjung : <strong class="black--text ml-1">{{ detail.user_event.length }}</strong>
                </div>

                <v-spacer />

                <v-btn
                  @click="prints()"
                  :disabled="process.print"
                  :loading="process.print"
                  color="#444444"
                  elevation="0"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  <v-icon>mdi-microsoft-excel</v-icon>
                  
                  <span
                    class="ml-1">
                    Export
                  </span>
                </v-btn>
              </div>

              <v-simple-table
                class="my-2"
                style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Foto
                      </th>
                      <th class="text-left">
                        Nomor Induk Pegawai
                      </th>
                      <th class="text-left">
                        Unit
                      </th>
                      <th class="text-left">
                        Nama Lengkap
                      </th>
                      <th class="text-left">
                        Telepon
                      </th>
                      <th class="text-left">
                        Tanggal
                      </th>
                    </tr>
                  </thead>
                  
                  <tbody>
                    <tr
                      v-for="(item, index) in detail.user_event"
                      :key="index"
                      style="opacity: 70%;">
                      <td
                        style="border: none !important;">
                        <v-avatar
                          size="30">
                          <v-img 
                            contain
                            alt="amanata" 
                            :src="item.user_image_url !== '' ? item.user_image_url : require('@/assets/image/image_default.png')"
                            class="ma-auto"
                            style="border-radius: 10px;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  color="white">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </td>
                      <td
                        style="border: none !important;">
                        {{ item.user_code }}
                      </td>
                      <td
                        style="border: none !important;">
                        {{ item.unit_name }}
                      </td>
                      <td
                        style="border: none !important;">
                        {{ item.user_name }}
                      </td>
                      <td
                        style="border: none !important;">
                        {{ item.user_mobilephone }}
                      </td>
                      <td
                        style="border: none !important;">
                        {{ item.created_datetime | datetime }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        detail: {},
        
        process: {
          load: false,
          
          print: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`admin/event/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      to_download () {
        let img = document.querySelector("#download_qr img").src

        const a = document.createElement('a')
        a.download = `QR-Code-Agenda-${this.detail.title}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.png`
        a.href = img
        a.click()
      },

      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          id: this.detail.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/event/export_participant`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.print = false

          if (res.status === 200) {
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')

            link.href = url
            link.setAttribute('download', `Presensi-Peserta-Agenda-${this.detail.title}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)

            document.body.appendChild(link)
            link.click()

          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>